import {
  Button,
  HStack,
  Icon,
  SimpleGrid,
  Text,
  VStack,
  useToast,
} from "@chakra-ui/react";
import { FloppyDisk } from "@phosphor-icons/react";
import React, { useState } from "react";
import { iconSize } from "../../const/sizes";
import PostEditor from "../blogComponents/PostEditor";
import { useFormik } from "formik";
import DOMPurify from "dompurify";
import cr from "../../lib/request";
import usePost from "../../globalState/usePost";

type Props = {
  data: string | null;
  id: string | undefined;
};

export default function CourseManfaatEditor({ data, id }: Props) {
  const [loading, setLoading] = useState<boolean>(false);
  const toast = useToast();
  const { post } = usePost();

  const formik = useFormik({
    validateOnChange: false,

    initialValues: {
      benefit: data,
    },

    onSubmit: (values, { resetForm }) => {
      const payload = new FormData();
      payload.append("benefit", post);

      setLoading(true);
      const url = `api/course/${id}/savebenefit`;
      cr.post(url, payload)
        .then((r) => {
          if (r.status === 200) {
            toast({
              title: r.data.message,
              status: "success",
              duration: 5000,
              isClosable: true,
            });
          }
        })
        .catch((error) => {
          console.log(error);
          toast({
            title: error?.response?.data?.message || "Error",
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  return (
    <>
      <HStack
        px={5}
        py={2}
        justify={"flex-end"}
        borderBottom={"1px solid var(--divider3)"}
      >
        <Button
          leftIcon={<Icon as={FloppyDisk} weight="fill" fontSize={iconSize} />}
          size={"sm"}
          colorScheme="ap"
          type="submit"
          form={"editManfaat"}
          isLoading={loading}
        >
          Save
        </Button>
      </HStack>

      <SimpleGrid columns={[1, null, 2]} flex={1}>
        <VStack
          align={"stretch"}
          borderRight={[null, null, "1px solid var(--divider3)"]}
          borderBottom={["1px solid var(--divider3)", null]}
          flex={1}
          p={5}
        >
          <Text fontWeight={600} fontSize={20}>
            Manfaat
          </Text>

          <form id="editManfaat" onSubmit={formik.handleSubmit}>
            <PostEditor data={data} />
          </form>
        </VStack>

        <VStack align={"stretch"} p={5}>
          <Text fontWeight={600} fontSize={20}>
            Manfaat
          </Text>

          <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(post) }} />
        </VStack>
      </SimpleGrid>
    </>
  );
}
